import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className={`font-heading text-xl md:text-2xl font-bold tracking-wide ${scrolled || !isHome ? 'text-foreground-950' : 'text-white'}`}>
              韩漫在线
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/romance"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
              }`}
            >
              分类
            </Link>
            <Link
              to="/category/action"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
              }`}
            >
              排行榜
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <button
              className={`w-9 h-9 flex items-center justify-center rounded-full cursor-pointer transition-colors ${
                scrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-white/80 hover:text-white'
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
            <button
              className={`hidden md:flex items-center justify-center px-5 py-2 rounded-full border text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                scrolled || !isHome
                  ? 'border-foreground-300 text-foreground-700 hover:border-primary-500 hover:text-primary-500'
                  : 'border-white/40 text-white hover:border-white hover:bg-white/10'
              }`}
            >
              登录
            </button>
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className={`md:hidden w-9 h-9 flex items-center justify-center rounded-full cursor-pointer transition-colors ${
                scrolled || !isHome ? 'text-foreground-700' : 'text-white/80'
              }`}
              aria-label="菜单"
            >
              <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap cursor-pointer">首页</Link>
            <Link to="/category/romance" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap cursor-pointer">分类浏览</Link>
            <Link to="/category/action" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap cursor-pointer">排行榜</Link>
            <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap cursor-pointer">关于我们</Link>
            <button className="mt-2 w-full px-5 py-2.5 rounded-full border border-primary-500 text-primary-500 text-sm font-medium hover:bg-primary-500 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
              登录
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}